import React from 'react';
import { connect } from 'react-redux';
import { Button, Header, Modal } from 'semantic-ui-react';
import { confirmModal } from '../../redux/actions/modals';

class ConfirmModal extends React.Component {

  onConfirm = () => {
    this.props.data.onConfirm().then(() => {
      this.props.confirmModal("", false, () => {} )
    })
  }

  onClose = () => {
    this.props.data.onClose().then(() => {
      this.props.confirmModal("", false, () => {} )
    })
  }

  render() {
    const { visible, message } = this.props.data;
    return (
        <Modal
          open={visible}
          onClose={this.onClose}
          closeIcon
          size="tiny"
        >
          <Header>{this.props.header || "Confirmation"}</Header>
          <Modal.Content>
            {message}
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={this.onClose}
              negative
            >
              {this.props.data.isYesNo ? "No" : "Cancel" }
            </Button>

            <Button
              onClick={this.onConfirm}
              positive
            >
              {this.props.data.isYesNo ? "Yes" : "Continue" }
            </Button>
          </Modal.Actions>  
        </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    data: state.confirmModal
  };
};

export default connect(mapStateToProps, { confirmModal })(ConfirmModal);

